<script>
    import { onMount, beforeUpdate } from 'svelte';
	import { fly } from 'svelte/transition';

    //import { storage } from '../firestore';
    import { currentUser } from '../stores/user.js';
    import { currentTenant } from '../stores/tenant.js';
    import { navigateTo } from 'svelte-router-spa'

    //---------- Props ----------//
    export let isOpen = false;
    export let avatarURL = '';
    let className = '';
    export {className as class};

    function signOut() {
        firebase.auth().signOut().then(async function() {
            // Sign-out successful.
            // We don't have to update the currentUser object manually, because the UserObserver will do that automatically!
            console.log('Logged out successfully.');
            		   // navigateTo('/login');

        }).catch(function(error) {
            // An error happened.
            console.log('Error logging out: ', error);
        });
    }

    const handleEscape = (e) => {
        if (e.key === 'Esc' || e.key === 'Escape') {
            isOpen = false;
        }
    }
    onMount(() => {
        document.addEventListener('keydown', handleEscape);
    })

    beforeUpdate(() => {
        console.log('beforeUpdate lifecycle hook');
        if ($currentUser) { hasAvatarURL() };
    })
    async function hasAvatarURL() {
        // avatarURL = '';
        if ($currentUser.photoURL) {
            avatarURL = $currentUser.photoURL;
            console.log('currentUser.photoURL:', $currentUser.photoURL);
            // return true;
        } else {
           // let mystorage = fbstorage;
            //let pathReference = await mystorage.ref(`users/${$currentUser.uid}/profile-image`);
            // let pathReference = await mystorage.ref(`users/gvJbgsa9InVreWaICUvE4O1jqfU2/profile-image`);
            // let pathReference = await fbstorage.ref(`user/profile-images/${$currentUser.uid}`);
            // avatarURL =  await pathReference.getDownloadURL();

            // pathReference.getDownloadURL().then(onResolve, onReject);
            // function onResolve(foundURL) {
            //     avatarURL = foundURL;
            //     console.log('avatarURL from fbstorage:', avatarURL);
            // }
            // function onReject(error) {
            //     // avatarURL = '';
            //     console.log('No uploaded avatar image found', error);
            // }

            // console.log('avatarURL from fbstorage:', avatarURL);
            // return (avatarURL !== '');
        }
        return (avatarURL !== '');
    }
</script>


{#if $currentUser}
<!-- <div class="relative">
    <div on:click={() => {isOpen = !isOpen}} class="relative z-10 flex items-center cursor-pointer">
        {#if avatarURL !== ''}
        <img class="rounded-full mr-2 object-cover border-2 border-gray-200" style="width:32px;height32px;" alt="{$currentUser.initials}" src={avatarURL}>
        {:else}
        <div class="rounded-full mr-2 flex justify-center items-center" style="width:32px;height32px;">
            <span>{$currentUser.initials}</span>
        </div>
        {/if}
    </div>

    {#if isOpen}
    <button on:click={() => {isOpen = false}} tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>
    <div on:click={() => {isOpen = false}} class="absolute right-0 mt-2 w-56 shadow-2xl bg-white">
        <a class="block px-4 py-2 hover:bg-gray-300" href='profile'>Profile</a>
        <button class="block px-4 py-2 w-full hover:bg-gray-300 text-left" on:click={() => { signOut(); }} >Logout</button>
    </div>
    {/if}
</div> -->

<div class="relative inline-block text-left {className}">
  <div>
      <div on:click={() => {isOpen = !isOpen}} class="transition ease-in-out duration-150 cursor-pointer">
        {#if avatarURL !== ''}
        <img class="" style="width:32px;height32px;" alt="{$currentUser.initials}" src={avatarURL}>
        {:else}
        <div class="rounded-full mr-2 flex justify-center items-center" style="width:32px;height32px;">
            <span>{$currentUser.initials}</span>
        </div>
        {/if}
      </div>
  </div>
  {#if isOpen}
      <button on:click={() => {isOpen = false}} tabindex="-1" class="fixed inset-0 h-full w-full cursor-default"></button>

  <div class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg z-50" transition:fly>
    <div class="rounded-md bg-white shadow-xs">
      <div class="py-1">
        <a href="/profile" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">Profile</a>
        <a href="/settings" class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">Settings</a>
      </div>
      <div class="border-t border-gray-100"></div>
        <button on:click={() => { signOut(); }} class="block w-full text-left px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900">Sign out</button>
    </div>
  </div>
    {/if}

</div>
<!-- {:else}
<div class="flex items-center">
    <a class="px-6 py-2" href="/login">Sign In</a>
</div> -->
{/if}